import type { WidgetItem, WidgetPaletteItem } from "@/types/dashboard"

export const generateWidgetId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

// Grid configuration
// h별 실제 높이 = h*ROW_HEIGHT + (h-1)*MARGIN_Y (MARGIN_Y = 24)
//   h=1  → 36      h=2  → 96      h=3  → 156
//   h=4  → 216     h=5  → 276     h=6  → 336
//   h=7  → 396     h=8  → 456     h=9  → 516
// 위젯 간격은 Settings 에서 크기 조절·추가 편의 고려해 24px (디자인 시안은 20px)
export const ROW_HEIGHT = 36
export const MARGIN: [number, number] = [24, 24]
export const CONTAINER_PADDING: [number, number] = [0, 0]
export const BREAKPOINTS = { lg: 1200, md: 996, sm: 768, xs: 480 }
export const COLS = { lg: 12, md: 12, sm: 6, xs: 1 }

// 기본 레이아웃 (12col)
// y=0   Calendar      (12w, h:5)  — 244px
// y=5   Quick Report  (6w, h:6)   | Recent Reports       (6w, h:6)  — 296px
// y=11  Activity Dist (6w, h:7)   | Session Distribution (6w, h:7)  — 348px
// y=18  Notice        (12w, h:5)  — 244px
// y=23  Team Summary  (12w, h:2)  — 88px  (WEB-2200: 최상단 → 최하단)
export const DEFAULT_WIDGETS: WidgetItem[] = [
  {
    id: generateWidgetId(),
    widgetType: "calendar",
    x: 0,
    y: 0,
    w: 12,
    h: 5,
    minW: 4,
    minH: 4,
    options: { defaultView: "weekly" },
  },
  {
    id: generateWidgetId(),
    widgetType: "quick-report",
    x: 0,
    y: 5,
    w: 6,
    h: 6,
    minW: 3,
    minH: 4,
    options: {},
  },
  {
    id: generateWidgetId(),
    widgetType: "recent-report",
    x: 6,
    y: 5,
    w: 6,
    h: 6,
    minW: 4,
    minH: 4,
    options: {},
  },
  {
    id: generateWidgetId(),
    widgetType: "activity-distribution",
    x: 0,
    y: 11,
    w: 6,
    h: 7,
    minW: 4,
    minH: 5,
    options: {},
  },
  {
    id: generateWidgetId(),
    widgetType: "session-distribution",
    x: 6,
    y: 11,
    w: 6,
    h: 7,
    minW: 4,
    minH: 5,
    options: {},
  },
  {
    id: generateWidgetId(),
    widgetType: "notice",
    x: 0,
    y: 18,
    w: 12,
    h: 5,
    minW: 3,
    minH: 3,
    options: {},
  },
  {
    id: generateWidgetId(),
    widgetType: "team-summary",
    x: 0,
    y: 23,
    w: 12,
    h: 2,
    minW: 4,
    minH: 2,
    options: {},
  },
]

export const WIDGET_PALETTE_ITEMS: WidgetPaletteItem[] = [
  {
    type: "team-summary",
    label: "Team Summary",
    icon: "team-summary",
    defaultWidth: 6,
    defaultHeight: 2,
    minWidth: 3,
    minHeight: 2,
    maxInstances: 1,
  },
  {
    type: "activity-distribution",
    label: "Activity Distribution",
    icon: "activity-distribution",
    defaultWidth: 6,
    defaultHeight: 7,
    minWidth: 4,
    minHeight: 5,
  },
  {
    type: "session-distribution",
    label: "Session Distribution",
    icon: "session-distribution",
    defaultWidth: 6,
    defaultHeight: 7,
    minWidth: 4,
    minHeight: 5,
  },
  {
    type: "calendar",
    label: "Activity Calendar",
    icon: "calendar",
    defaultWidth: 6,
    defaultHeight: 5,
    minWidth: 4,
    minHeight: 4,
  },
  {
    type: "notice",
    label: "Notices",
    icon: "notice",
    defaultWidth: 6,
    defaultHeight: 5,
    minWidth: 3,
    minHeight: 3,
    maxInstances: 1,
  },
  {
    type: "quick-report",
    label: "Quick Report",
    icon: "quick-report",
    defaultWidth: 6,
    defaultHeight: 6,
    minWidth: 4,
    minHeight: 4,
  },
  {
    type: "recent-report",
    label: "Recent Reports",
    icon: "recent-report",
    defaultWidth: 6,
    defaultHeight: 6,
    minWidth: 4,
    minHeight: 4,
    maxInstances: 1,
  },
]
